import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=aa2f1de6&scoped=true&"
var script = {}
import style0 from "./DownloadPage.vue?vue&type=style&index=0&id=aa2f1de6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2f1de6",
  null
  
)

export default component.exports